import { useApi, discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import { useCallback, useEffect, useState } from 'react';

export function useMediaUrl() {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const [baseUrl, setBaseUrl] = useState<string>('');

  useEffect(() => {
    discoveryApi.getBaseUrl('onboarding').then(url => setBaseUrl(url));
  }, [discoveryApi]);

  const buildMediaUrl = useCallback(
    (mediaPath: string) => (baseUrl ? `${baseUrl}/media/${mediaPath}` : ''),
    [baseUrl],
  );

  const fetchMediaUrl = useCallback(
    async (mediaPath: string): Promise<string> => {
      const url = `${baseUrl}/media/${mediaPath}`;
      const response = await fetchApi.fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch media: ${response.statusText}`);
      }
      const blob = await response.blob();
      return URL.createObjectURL(blob);
    },
    [baseUrl, fetchApi],
  );

  return { baseUrl, buildMediaUrl, fetchMediaUrl };
}
